<script setup>
import { ref, inject } from 'vue'
import useFavorites from '@/Shared/useFavorites.js'
import ButtonCircle from '@/Shared/Buttons/ButtonCircle'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'
import ModalAccordion from '@/Shared/Modal/Modal2Accordion'

const props = defineProps({
  url: String,
})

const category = inject('category')
const data = inject('data')

const active = ref(false)
const toggle = () => {
  active.value = !active.value
}
const { updateFavoriteList } = useFavorites({ category: category })
</script>

<template>
  <transition name="slide">
    <ModalAccordion v-if="active" @toggle="toggle" />
  </transition>
  <ul class="btn-set">
    <li><ButtonCircle icon="link" @click="toggle" /></li>
    <li><ButtonRounded text="詳細を見る" :url="props.url" icon="arrow" /></li>
    <li><ButtonFavoriteToggle v-if="category !== 'news'" class="btn-circle w-[55px]" :category="category" :slug="data[`${category}Slug`]" @click="updateFavoriteList" /></li>
  </ul>
</template>
